import ListMail from "./ListMail";


const ReceivedMail = () => {
    const urlParam = []
    urlParam['direction'] = 'received'

    return (
        <ListMail
            urlParam={urlParam}
            pageTitle={'mailbox.received.list.title'}
        />
    )
}


export default ReceivedMail